import React, { memo, forwardRef } from 'react';
import clsx from 'clsx';
import './Radio.less';
import { RadioValueType } from './types';
import { ReactComponent as IconUnchecked } from 'assets/images/radio_unchecked.svg';
import { ReactComponent as IconChecked } from 'assets/images/radio_checked.svg';

interface Props<T extends RadioValueType>
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'value'> {
  value: T;
}

function RadioInner<T extends RadioValueType>(
  { className, checked, disabled, value, onChange, ...props }: Props<T>,
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  const Icon = checked ? IconChecked : IconUnchecked;

  return (
    <label
      className={clsx('custom-radio', className, {
        'is-checked': checked,
        'is-disabled': disabled,
      })}
    >
      <input
        {...props}
        type="radio"
        ref={ref}
        value={value as string | number | readonly string[]}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className="custom-radio__hidden-input"
      />

      <Icon className="custom-radio__icon" />
    </label>
  );
}

export const Radio = memo(forwardRef(RadioInner)) as <T extends RadioValueType>(
  props: Props<T> & { ref?: React.ForwardedRef<HTMLInputElement> },
) => React.ReactElement;

export default Radio;
